import React, { useEffect, useRef, useState } from 'react';
import { Grid, Snackbar} from '@mui/material';
import { connect } from 'react-redux';
import * as menuActions from '../../store/actions/breadcrumb';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../style/common.css';
import Select from 'react-select';
import * as Styled from '../../components/styled-components/Styled-Components';
import DefaultTable from '../../components/Table';
import TableCell from '@mui/material/TableCell';
import appConfig from "../../config/appConfig";
import SkeletonGridLoader from '../../components/SkeletonGridLoader';
import RemoveDialog from '../../components/RemoveDialog';
import * as userActions from '../../store/actions/userManagement';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SendIcon from '@mui/icons-material/Send';
import DownloadIcon from '@mui/icons-material/Download';
import { MultiSelect } from "react-multi-select-component";
import { endOfDay, setISODay, startOfDay } from 'date-fns'
import FormControl from '@mui/material/FormControl';
import { useForm } from 'react-hook-form';
import { CalculateUserTzToUTCTz } from '../../components/Utils';
import { useLogout } from '../../components/Utils';
import {  createUserWithEmailAndPassword } from 'firebase/auth';
import {auth} from '../../config/firebase-config'
import { useTranslation } from 'react-i18next';
import FilterListIcon from '@mui/icons-material/FilterList';
import * as auditActions from '../../store/actions/auditLog';


const dropDownlistCss = { mt: 1, mb: 1, borderRadius: "5px", border: `1px solid ${appConfig.colors.darkblue}`, background: "#fcfcfb", width: "100%", '.MuiAutocomplete-input': { height: "5px" } };

const gridItemCss = { '&.MuiGrid-item': { pt: 0, pl: 2, pr: 2 } };

const mb = { marginBottom: 0, fontWeight: "bold", color: appConfig.colors.darkgray };
const SearchButtonStyle = {
  textTransform: 'none',
  height: "38px",
  minWidth: 'unset',
  borderRadius: "0 5px 5px 0",
  boxShadow: 'none',
  padding: '0px 10px'
}
const UserManagement = ({setBreadcrumb, fetchUserList, userManagementData, deleteUserMgt, deletedUser, getBUnitFilterDetails, bunitFilterList, triggerMail, triggerMailData, exportReport, fetchAuditUserList, auditUserList}) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const sessionFilter = JSON.parse(window.sessionStorage.getItem("filterValuesUserMgt"));
  const [isFilterOpen, setIsFilterOpen] = useState(sessionFilter?.isFilterOpen || false);

  const isMounted = useRef(false);
  const onLogout = useLogout();
  const params = useLocation();
  const [removeDialogOpen, setRemoveDialogOpen] = useState(false);
  const [filterList, setFilterList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filterValues, setFilterValues] = useState()
  const [userList, setUserList] = useState();
  const [byName, setByName] = useState(sessionFilter?.byName || '');
  const debounceTimeout = useRef(null);
  const [statusFilter, setStatusFilter] = useState( [
    {
    label: "Active",
    value: "active",
  },  {
    label: "Inactive",
    value: "inactive",
  },
])
const [selectedDate, setSelectedDate] = useState({
  startDate: startOfDay(new Date()),
  endDate: endOfDay(new Date().setDate(new Date().getDate() + 30))
});
const filterInitialState = {
  locations: [],
  templates: [],
  startDate: CalculateUserTzToUTCTz(selectedDate?.startDate?.toISOString() || startOfDay(new Date()).toISOString()),
  endDate: CalculateUserTzToUTCTz(selectedDate?.endDate?.toISOString() || endOfDay(new Date()).toISOString())
}
const [filterData, setFilterData] = useState(filterInitialState);
const [pagination, setPagination] = useState({ limit: sessionFilter?.pagination?.limit || 10, offset: sessionFilter?.pagination?.offset || 1 });
const [businessUnitFilter, setBusinessUnitFilter] = useState(params.state && params.state.dropdownSelected ? params.state.dropdownSelected : { key: 'All', value: "all" });
const [selected, setSelected] = useState(null);
const [sortValue, setSortValue] = useState({sortBy:"modifiedTime", sortOrder: "desc"});
const [searchText, setSearchText] = useState("");
const [selectedBusinessUnit,setSelectedBusinessUnit] = useState({});
const [userListDetails, setUserListDetails] = useState([]);
const [apiError, setAPIError] = useState("");
const [open, setOpen] = useState(false);
const [message, setMessage] = useState(false);
const handleToggle = () => {
  setIsFilterOpen(!isFilterOpen); // Toggle between true and false
};
const [selectedBusinessUnits, setSelectedBusinessUnits] = useState(sessionFilter?.filterByBusinessUnit || []);
const [selectedLocationNames, setSelectedLocationNames] = useState(sessionFilter?.filterByBusinessUnitLocation || []);
const [selectedStatus, setSelectedStatus] = useState(
  sessionFilter?.statusFilter || []
);

const businessUnitOptions = filterList?.map((businessUnit) => ({
  label: businessUnit?.businessUnitName,
  value: businessUnit?.businessUnitId,
})).sort((a, b) => a?.label?.localeCompare(b.label));;

const defaultFilter = businessUnitOptions?.map(item => item.value);

  

const getSelectedLocations = () => {
  return filterList
    .filter((businessUnit) => selectedBusinessUnits?.some((selected) => selected.value === businessUnit.businessUnitId))
    .flatMap((businessUnit) =>  businessUnit?.businessLocation?.map((location) => ({
      "locationId": location?.id,
      "locationName": location?.locationName
    })));
};
const updateLocationOptions = () => {
  const locations = getSelectedLocations();
  const locationOptions = [...new Set(locations)]?.map((item) => ({
    label: item?.locationName,
    value: item?.locationId,
  })).sort((a, b) => a?.label?.localeCompare(b.label));;

  const businessUnitOptions = filterList?.map((businessUnit) => ({
    label: businessUnit?.businessUnitName,
    value: businessUnit?.businessUnitId,
  }));
  return locationOptions;
};
const locationOptions = updateLocationOptions();

const handleBusinessUnitChange = (selectedOptions) => {
  setSelectedBusinessUnits(selectedOptions);
  const FilList = filterList
    .filter((businessUnit) => selectedOptions?.some((selected) => selected.value === businessUnit.businessUnitId))
    .flatMap((businessUnit) =>  businessUnit?.businessLocation?.map((location) => ({
      "value": location?.id,
      "label": location?.locationName
    })));
    const matchedLocations = FilList.filter((location) =>
    selectedLocationNames.some((selected) => selected.value === location.value)
  );
  updateLocationOptions();
  setSelectedLocationNames(matchedLocations);
  // setSelectedLocationNames([]);
};


const handleLocationChange = (selectedOptions) => {
  setSelectedLocationNames(selectedOptions);
};


const handleStatusChange = (selectedOptions) => {
  setSelectedStatus(selectedOptions);
};
const { handleSubmit } = useForm();

useEffect(()=>{
  getBUnitFilterDetails();
},[])

useEffect(()=>{
if(bunitFilterList && bunitFilterList?.status === 200){
  const dataArr = bunitFilterList?.data || []
  setFilterList(dataArr);
  const defaultFilter = dataArr?.map((businessUnit) => ({
    label: businessUnit?.businessUnitName,
    value: businessUnit?.businessUnitId,
  }));
  setSelectedBusinessUnits(sessionFilter?.filterByBusinessUnit || defaultFilter);
  const filterInitValues = {
    filterByBusinessUnit: businessUnitOptions?.map(item => item.value),
    filterByBusinessUnitLocation: "",
    startDate: filterData.startDate.toISOString(),
    endDate: filterData.endDate.toISOString(),
    businessId :[],
    location :  '',
    statusFilter: 'all',
    filterByStatus: sessionFilter?.filterByStatus ||  'all',
    filterByName: sessionFilter?.filterByName || ''
  }
  setFilterValues(sessionFilter || filterInitValues);
  fetchUserList(pagination.limit, pagination.offset, sessionFilter || filterInitValues);
} else if(bunitFilterList && bunitFilterList?.status === 401){
  onLogout();
}
},[bunitFilterList])
useEffect(()=>{
  if(auditUserList && auditUserList?.auditUserList && auditUserList?.status === 200){
    const data = auditUserList?.auditUserList;
    const namesArray =
    data?.map(item => ({
      value: item.email,
      label:  item.name
    }));
    setUserList(namesArray)
  } else if (auditUserList && auditUserList?.status === 401) {
    onLogout();
  }
},[auditUserList]);

const debounceSearch = (query) => {
  if (debounceTimeout.current) {
    clearTimeout(debounceTimeout.current);
  }
  debounceTimeout.current = setTimeout(() => {
    fetchAuditUserList(query);
  }, 300);
};
const handleInputChange = (newValue) => {
  if(newValue.length > 0) {
    debounceSearch(newValue);
  }
};
const handleByNameChange = (value) => {
  if (value === null) {
    setUserList([])
  } 
  setByName(value); 
};

useEffect(()=>{
  if(triggerMailData && triggerMailData?.status === 401){
    onLogout();
  }
  },[triggerMailData])



const handleDialogOpen = (card) => {
  setRemoveDialogOpen(true);
};
const handleDialogClose = () => {
  setRemoveDialogOpen(false);
};
const onDeleteAction = () => {
  const data = {
    "id":selectedBusinessUnit.id
  }
  setIsLoading(true);
  deleteUserMgt(data); 
}

useEffect(() => {
setBreadcrumb(t('User Management'))
if (params.state && params.state.dropdownSelected) {
  setBusinessUnitFilter(params.state.dropdownSelected);
}
}, [params]);
const handlePagination = (limit, offset) => {
  const data1 = JSON.parse(window.sessionStorage.getItem('filterValuesUserMgt'));
  if (data1 && data1.pagination) {
    data1.pagination.limit = limit; // Set your new limit value
    data1.pagination.offset = offset;
    window.sessionStorage.setItem('filterValuesUserMgt', JSON.stringify(data1));
  } else {
    const data2 = {
      pagination: {
          limit: limit,  // Default limit value
          offset: offset   // Default offset value
      }
    };
    window.sessionStorage.setItem('filterValuesUserMgt', JSON.stringify(data2));
  }
setPagination({ limit, offset })
}

useEffect(()=> {
if(deletedUser && deletedUser.status === 200) {
  setIsLoading(false);
  handleDialogClose();
  fetchUserList(pagination.limit, pagination.offset, filterValues);
} else if(deletedUser && deletedUser.status === 401) {
  onLogout();
}
},[deletedUser])

const handleClose = (event, reason) => {
if (reason === 'clickaway') {
  return;
}
setOpen(false);
};

useEffect(() => {
const filterInitValues = {
  filterByBusinessUnit: businessUnitOptions?.map(item => item.value),
  filterByBusinessUnitLocation: "",
  startDate: filterData.startDate.toISOString(),
  endDate: filterData.endDate.toISOString(),
  businessId :[],
  location :  '',
  statusFilter: 'all',
  filterByStatus:  'all',
  filterByName: ''
}
setFilterValues(sessionFilter || filterInitValues);
fetchUserList(pagination.limit, pagination.offset, sessionFilter || filterInitValues);
}, [])
useEffect(() => {
isMounted.current = true;
fetchUserList(pagination.limit, pagination.offset, filterValues, searchText);
}, [JSON.stringify(pagination), businessUnitFilter,JSON.stringify(sortValue)])


useEffect(()=>{
    if(userManagementData && userManagementData?.userManagementData && !userManagementData.isError){
      const data = userManagementData.userManagementData;
      setUserListDetails({data:data})
    } else if(userManagementData && userManagementData.userManagementData && userManagementData.userManagementData.status === 401){
      onLogout();
    }

},[userManagementData])

const renderCells = (row) => {
let BuinssUnitName = '';
let BusinnessLocationData = ''
const businessUntis = row?.locationData?.map((item,i)=>{
  if(i=== 0){
    BuinssUnitName = item.businessUnitName 
  }else{
    BuinssUnitName = BuinssUnitName +", "+  item.businessUnitName 
  }
})

row?.locationData?.map((item,i)=>{
  item?.businessUnitLocations?.map((data,j)=>{
    if(i=== 0 && j===0){
      BusinnessLocationData = BusinnessLocationData + data?.locationName
    }else{
      BusinnessLocationData = BusinnessLocationData  +", "+ data?.locationName
    }
  })
})

const userName = `${row.firstName} ${row.middleName ? row.middleName + ". " : ""}${row.lastName}`;
return <>
  <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{userName ? userName : "-"}</TableCell>
  <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{row.email ? row.email : '-'}</TableCell>
  <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{row.roleId === 201 ? "Admin" : "Business User"}</TableCell>
  <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{row.isActive ? "Active" : "Inactive"}</TableCell>
  <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{BuinssUnitName}</TableCell>
  <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{BusinnessLocationData}</TableCell>

  {/* <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16 }}>{row.locationData && row.locationData[0] ? row.locationData[0].businessUnitLocations && row.locationData[0].businessUnitLocations[0] && row.locationData[0].businessUnitLocations[0].address : "-"}</TableCell> */}
</>
}
// const generatePassword = () => {
//   let charset = "";
//   let newPassword = "";
//   const passwordLength = 12;

//   charset += "!@#$%^&*";
//   charset += "0123456789";
//   charset += "abcdefghijklmnopqrstuvwxyz";
//    charset += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

//   for (let i = 0; i < passwordLength; i++) {
//       newPassword += charset.charAt(Math.floor(Math.random() * charset.length));
//   }
//   return newPassword
// };
// const addUser = async (data) => {
//   try{
//    const userCredential = await createUserWithEmailAndPassword(auth, data.email, data.password);
//    const payload = {
//       "firstName": data?.firstName,
//       "email": data?.email,
//       "pwd":  data?.password
//    }
//    triggerMail(payload);
//    setMessage("Email triggered successfully");
//    setOpen(true);
//   }catch(e){
//    setIsLoading(false);
//    if(e.code === "auth/email-already-in-use"){
//        setAPIError(t("Email Address already exists"))
//        setMessage(t("Email Address already exists"));
//        setOpen(true);
//    }else{
//        setAPIError(t("Something went wrong"))
//        setOpen(true);
//        setMessage(t("Something went wrong Try again later"));
//    }
//   }
// }
// const sendInvite  = (row)  =>  {
//   const data = {
//     "email": row?.email,
//     "password": generatePassword(),
//     "firstName": row?.firstName,
//     "middleName": row?.middlename,
//     "lastName": row?.lastname,
//     "roleId": row?.roleId,
//     "isActive": row?.isActive === "Yes" ? true : false,
//     "locationIdList": row?.locationData,
//     "lastModifiedBy": "Build Script",
//   }
//   addUser(data)
// }

const renderActionButton = (row) => {
  return <div className='display-flex' style={{gap: 10, display: 'flex'}}>
          <IconButton sx={{border:`1px solid ${appConfig.colors.darkblue}`, padding:'2px' }} onClick={() => {navigate('/view-user/'+row.id,{ state: { user: row } })}}
              title={t('View')} aria-label="delete" size="small">
             <VisibilityIcon sx={{fontSize: 15, borderRadius:"50%", color:appConfig.colors.darkblue}} />
          </IconButton>
          <IconButton sx={{border:`1px solid ${appConfig.colors.darkblue}`, padding:'2px' }} onClick={() => {navigate('/edit-user/'+row.id,{ state: { user: row } })}}
              title={t('Edit')} aria-label="delete" size="small">
             <EditIcon sx={{fontSize: 15, borderRadius:"50%", color:appConfig.colors.darkblue}} />
          </IconButton>
          <IconButton sx={{border:`1px solid ${appConfig.colors.darkblue}`, padding:'2px' }} onClick={()=>{setSelectedBusinessUnit(row);handleDialogOpen(row)}}
              title={t('Delete')} aria-label="delete" size="small">
             <DeleteIcon sx={{fontSize: 15, borderRadius:"50%", color:appConfig.colors.darkblue}} />
          </IconButton>
          {/* {row?.isFirstTimeLogin && (
            <IconButton sx={{border:`1px solid ${appConfig.colors.darkblue}`, padding:'2px' }} onClick={()=>{setSelectedBusinessUnit(row);sendInvite(row)}}
              title={t('Send Invite')}aria-label="delete" size="small">
             <SendIcon sx={{fontSize: 15, borderRadius:"50%", color:appConfig.colors.darkblue}} />
            </IconButton>
          )} */}
  </div>
}

const handleSort = (value) => {
  setSortValue(value)
}

const onSubmit = () => {
  const filterValues2 = {
    filterByBusinessUnit: selectedBusinessUnits?.length === businessUnitOptions?.length ? [] : selectedBusinessUnits || businessUnitOptions?.map(item => item.value),
    filterByBusinessUnitLocation: selectedLocationNames?.length === locationOptions?.length ? [] : selectedLocationNames || locationOptions?.map(item => item.value),
    // filterByBusinessUnit: selectedBusinessUnits || businessUnitOptions?.map(item => item.value),
    // filterByBusinessUnitLocation: selectedLocationNames || "",
    startDate: filterData.startDate.toISOString(),
    endDate: filterData.endDate.toISOString(),
    businessId : selectedBusinessUnits?.length === businessUnitOptions?.length ? [] :  selectedBusinessUnits?.map(item => item.value) || businessUnitOptions?.map(item => item.value),
    location : selectedLocationNames?.length === locationOptions?.length ? [] : selectedLocationNames || locationOptions?.map(item => item.value),
    statusFilter: selectedStatus || 'all',
    filterByName: byName?.value || '',
    byName: byName,
    isFilterOpen: isFilterOpen,
    pagination: { limit: 10, offset: 1 },
    filterByStatus: selectedStatus?.map(item => item.value) || 'all',
  }
  setFilterValues(filterValues2);
  sessionStorage.setItem("filterValuesUserMgt", JSON.stringify(filterValues2));
  setPagination({limit: 10, offset: 1});
  fetchUserList(10, 1, filterValues2);
};

const onClear = () => {
  const filterInitValues = {
    filterByBusinessUnit: businessUnitOptions?.map(item => item.value),
    filterByBusinessUnitLocation: "",
    startDate: filterData.startDate.toISOString(),
    endDate: filterData.endDate.toISOString(),
    businessId :[],
    location :  '',
    statusFilter: 'all',
    filterByStatus:  'all',
    filterByName: ''
  }
  const defaultFilter = filterList?.map((businessUnit) => ({
    label: businessUnit?.businessUnitName,
    value: businessUnit?.businessUnitId,
  }));

  setSelectedBusinessUnits(defaultFilter);
  setSelectedLocationNames([]);
  setSelectedStatus([]);
  setUserList([]);
  setByName('');
  setFilterValues(filterInitValues);
  setFilterData(filterInitialState);
  sessionStorage.removeItem("filterValuesUserMgt");
  setSelectedDate({
      startDate: CalculateUserTzToUTCTz(startOfDay(new Date().setDate(new Date().getDate() - 30))),
      endDate: CalculateUserTzToUTCTz(endOfDay(new Date()))
  })
  // fetchFiltersData(filterInitValues);
  setSelected(null);
  setPagination({limit: 10, offset: 1});
  fetchUserList(10, 1, filterInitValues, searchText);
}

const handleExport = () => {
  exportReport(filterValues)
}
  return (
    <div style={{paddingRight: 10}}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} xl={6} lg={6} md={6}>
          <h1 className='page-heading' ><b>{t("User Management")}</b></h1>
        </Grid>
        <Grid item xs={12} sm={6} xl={6} lg={6} md={6} sx={{textAlign: {xs:"left", sm:"right", lg:"right", xl:"right",md:"right"}}}>
            <div>
              {/* <Styled.CancelButton
                variant="outlined"
                style={{marginRight: 10}}
                className="xs-bold"
                onClick={handleExport}
              >
                <DownloadIcon sx={{fontSize: 15, borderRadius:"50%", marginRight: '5px'}} /> Export
              </Styled.CancelButton> */}
              <div onClick={handleToggle} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', float: 'right', marginBottom: 10, fontFamily: appConfig?.fontfamily }}>
                    <IconButton>
                    <FilterListIcon style={{ color: '#000' }}  />
                    </IconButton>
                    <b>{isFilterOpen ? t('hideFilters') : t('showFilters')}</b>
                </div>
              <Styled.PrimaryButton
                variant="contained"
                className="xs-bold"
                onClick={() => navigate('/create-user', { state: { initState: true } })}
              >
                {t("Create")}
              </Styled.PrimaryButton>
            </div>
            
        </Grid>
      </Grid>
      <hr className='blue-border mb-30' />
      <Snackbar
        open={open}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={5000}
        onClose={handleClose}
        message={message}
      />
      {removeDialogOpen && (
          <RemoveDialog 
          openDialog={removeDialogOpen}
          isLoading={isLoading}
          onClose={handleDialogClose}
          cardContent={t("Are you sure want to delete?")}
          onSave={onDeleteAction}
          />
      )}
      <div className='filter-container'>
            {isFilterOpen && (
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2} style={{alignItems: 'flex-end'}}>
                        <Grid
                            item
                            xs={12} lg={2.5} md={4} xl={2.5}
                            sx={gridItemCss}
                        >
                            <p style={mb}>{t("By Business Units")}<span style={{color:"red"}}>{" *"}</span></p>
                            <FormControl sx={dropDownlistCss}>
                                <MultiSelect
                                  options={businessUnitOptions}
                                  value={selectedBusinessUnits || defaultFilter}
                                  onChange={handleBusinessUnitChange}
                                  labelledBy="Select"
                                  overrideStrings={{
                                    "allItemsAreSelected": t("All items are selected."),
                                    "noOptions": t("No options"),
                                    "search": t("Search"),
                                    "selectAll": t("Select All"),
                                    "selectSomeItems": t("Select...")
                                  }}
                                />
                            </FormControl>

                        </Grid>

                        <Grid
                            item
                            xs={12} lg={2.5} md={4} xl={2.5}
                            sx={gridItemCss}
                        >
                            <p style={mb}>{t("By Business Locations")}</p>
                            <FormControl sx={dropDownlistCss}>
                                <MultiSelect
                                  options={locationOptions}
                                  value={selectedLocationNames}
                                  onChange={handleLocationChange}
                                  labelledBy="Select"
                                  overrideStrings={{
                                    "allItemsAreSelected": t("All items are selected."),
                                    "noOptions": t("No options"),
                                    "search": t("Search"),
                                    "selectAll": t("Select All"),
                                    "selectSomeItems": t("Select...")
                                  }}
                                />
                            </FormControl>

                        </Grid>

                        <Grid
                            item
                            xs={12} lg={2.5} md={4} xl={2.5}
                            sx={gridItemCss}
                        >
                            <p style={mb}>{t("By Status")}</p>
                            <FormControl sx={dropDownlistCss}>
                                <MultiSelect
                                  options={statusFilter}
                                  value={selectedStatus}
                                  onChange={handleStatusChange}
                                  labelledBy="Select"
                                  overrideStrings={{
                                    "allItemsAreSelected": t("All items are selected."),
                                    "noOptions": t("No options"),
                                    "search": t("Search"),
                                    "selectAll": t("Select All"),
                                    "selectSomeItems": t("Select...")
                                  }}
                                />
                            </FormControl>

                        </Grid>
                        
                      
                        {/* <Grid item
                            xs={12} lg={2} md={2} xl={2}
                            sx={gridItemCss} /> */}

                        
                         <Grid  item   xs={12} lg={2.5} md={4} xl={2.5} sx={gridItemCss}>
                            <p style={mb}>{t("By User")}</p>
                            <FormControl className="default-search" sx={dropDownlistCss}>
                              <Select
                                className="autocomplete"
                                value={byName}
                                onChange={handleByNameChange}
                                onInputChange={handleInputChange} // Capture user input for search term
                                options={userList?.map((user) => ({
                                  label: user.label,
                                  value: user.value,
                                }))}
                                isClearable={true}
                                placeholder={t('Search')}
                                noOptionsMessage={() => (t('No options'))}
                              />
                            </FormControl>
                        </Grid>
                        <Grid
                            item
                            xs={12} lg={1} md={2} xl={1} sm={2}
                            // sx={gridItemCss}
                        >
                            <FormControl sx={dropDownlistCss} className="filter-btn">
                                <Styled.PrimaryButton type="submit">
                                {t("Apply")}
                                </Styled.PrimaryButton>

                            </FormControl>
                        </Grid>

                        <Grid
                            item
                            xs={12} lg={1} md={2} xl={1} sm={2}
                            style={{paddingLeft: "10px"}}
                            // sx={gridItemCss}
                        >
                            <FormControl sx={dropDownlistCss} className="filter-btn">

                                <Styled.CancelButton  sx={{padding:'5px'}} onClick={() => { onClear() }} >
                                  {t("Clear")} 
                                </Styled.CancelButton>
                            </FormControl>
                        </Grid>
                        {/* <Grid
                            item
                            xs={12} lg={2.5} md={8} xl={2.5}
                            sx={gridItemCss}
                            style={{display:'flex',alignItems:'end', flexDirection: 'column',paddingRight: 0}}
                            id="userTable"
                        >
                           <p style={mb}></p>
                            <div style={{position: 'relative', top: '-8px'}} className='search-table'> 
                            <TextField
                                placeholder={"Search by username"} value={searchText} 
                                onChange={(e) => {
                                  setSearchText(e.target.value);
                                }} sx={
                                  {
                                    '& .MuiInputBase-input': {
                                      backgroundColor: '#fcfcfb',
                                      fontSize: 14,
                                      padding: "7px",
                                      paddingLeft: "15px",
                                      height: "38px",
                                      minWidth: 'unset',
                                      border: "1px solid #005974",
                                      borderRadius: "5px 0 0 5px",
                                      outline: "none",
                                      textOverflow: "ellipsis",
                                      overflow: "hidden",
                                      boxSizing: 'border-box'
                                    }
                                  }
                                }
                              />
                                {searchText?.length > 0 ? <ClearIcon onClick={()=>{handleSearch('');}} fontSize="small" sx={{ position: 'absolute', right: 80, top: 8, color: appConfig.colors.blueprimary }} /> : null}

                                <Styled.CancelButton
                                  style={{ ...SearchButtonStyle }}
                                  variant="contained"
                                  onClick={() => handleSearch(searchText.trim())}
                                >
                                  <SearchIcon />
                                </Styled.CancelButton>
                              </div> 

                        </Grid> */}
                        
                    </Grid>
                </form>
            )}
            </div>
      { userManagementData?.isLoading ? <SkeletonGridLoader />
        :
        <div>
      <DefaultTable
          title={t("User Management")}
          handlePagination={handlePagination}
          headers={[{name:t('Name'), sortEnabled:false},{name:t('Email Address'), sortEnabled:false},{name:t('Role'), sortEnabled:false},{name:t('Status'), sortEnabled:false},{name:t('Business Unit'), sortEnabled:false},{name:t('Location'), sortEnabled:false}]}
          data={userListDetails?.data}
          totalCount={userManagementData?.count}
          currentPage={pagination.offset}
          currentLimit={pagination.limit}
          defaultFilter={businessUnitFilter}
          selected={selected}
          renderCustomCells
          renderCells={renderCells}
          isFilterOpen={isFilterOpen}
          // isSearchEnabled
          // searchCallback={(text) => handleSearch(text)}
          // searchKey={searchText}
          searchPlaceholderText={t('Search by user name')}
          hasAction 
          renderActionButton={renderActionButton}
          isSortEnabled
        />
        </div>
  }
      </div>
  );
}

const mapStateToProps = (state) => ({ 
  userManagementData: state.userReducer.userManagementData,
  deletedUser: state.userReducer.deletedUser,
  bunitFilterList: state.userReducer.bunitFilterList,
  triggerMailData: state.userReducer.triggerMailData,
  auditUserList: state.auditLog.auditUserList
  })

const mapDispatchToProps = (dispatch) => {
    return {
        setBreadcrumb: (menu) => dispatch(menuActions.changeMenu(menu)),
        fetchUserList: (limit, offset, filter, search) => dispatch(userActions.getUserMgtList(limit, offset, filter, search)),
        deleteUserMgt: (id) => dispatch(userActions.deleteUserMgt(id)),
        getBUnitFilterDetails: () => dispatch(userActions.getBUnitFilterDetails()),
        triggerMail: (data) => dispatch(userActions.triggerMail(data)),
        fetchAuditUserList: (search) => dispatch(auditActions.fetchAuditUserList(search)),
        exportReport: (data,tableobj,searchText)=>dispatch(userActions.exportReport(data,tableobj, searchText))
    };
};
UserManagement.propTypes = {
    setBreadcrumb: PropTypes.func.isRequired,
    fetchUserList: PropTypes.func.isRequired,
    userManagementData: PropTypes.object.isRequired,
    getBUnitFilterDetails: PropTypes.func.isRequired,
    deleteUserMgt: PropTypes.func.isRequired,
    triggerMail: PropTypes.func.isRequired,
    exportReport:PropTypes.func.isRequired,
    auditUserList: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);
